'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AUTH_QUERIES } from '../../infrastructure/auth/utils/queries';
import type {
  GenerateOtpRequest,
  GenerateOtpResponse,
  VerifyOtpRequest,
  VerifyOtpResponse,
  AssociateOtpRequest,
  AssociateOtpResponse,
  VerifyEmailRequest,
  VerifyEmailResponse,
  RegisterRequest,
  RegisterResponse,
  RegisterWithPasswordRequest,
  RegisterWithPasswordResponse,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
} from '../../infrastructure/auth/utils/types';

export const useAuthService = () => {
  const queryClient = useQueryClient();

  const useGenerateOtp = () =>
    useMutation<GenerateOtpResponse, unknown, GenerateOtpRequest>(AUTH_QUERIES.generateOtp());

  const useVerifyOtp = () =>
    useMutation<VerifyOtpResponse, unknown, VerifyOtpRequest>(AUTH_QUERIES.verifyOtp(queryClient));

  const useAssociateOtp = () =>
    useMutation<AssociateOtpResponse, unknown, AssociateOtpRequest>(AUTH_QUERIES.associateOtp(queryClient));

  const useVerifyEmail = () =>
    useMutation<VerifyEmailResponse, unknown, VerifyEmailRequest>(AUTH_QUERIES.verifyEmail(queryClient));

  const useRegister = () => useMutation<RegisterResponse, unknown, RegisterRequest>(AUTH_QUERIES.register(queryClient));

  const useRegisterWithPassword = () =>
    useMutation<RegisterWithPasswordResponse, unknown, RegisterWithPasswordRequest>(
      AUTH_QUERIES.registerWithPassword(queryClient),
    );

  const useLogin = () => useMutation<LoginResponse, unknown, LoginRequest>(AUTH_QUERIES.login(queryClient));

  const useLogout = () => useMutation<LogoutResponse, unknown, void>(AUTH_QUERIES.logout());

  return {
    useGenerateOtp,
    useVerifyOtp,
    useAssociateOtp,
    useVerifyEmail,
    useRegister,
    useRegisterWithPassword,
    useLogin,
    useLogout,
  };
};
